import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@services/api.service';
import { map } from 'rxjs/operators';
import { LoggerService } from '@services/logger.service';
import { CommissionsSignalmanModel } from '@/models/tables/commissions-signalman.model';

@Injectable({
  providedIn: 'root',
})
export class CommissionsSignalmanService extends ApiService {
  getAll(): Observable<any> {
    return this.http.get<any>(this.baseUrl + `/tables/commissionSignalmanConfigurazions`);
  }

  getCommissionSignalmanTypes(): Observable<any> {
    return this.http.get<any>(
      this.baseUrl + `/tables/commissionSignalmanConfigurazions/commissionSignalmanTypes`,
    );
  }

  deleteCommission(commissionConfigurationId: number) {
    return this.http
      .delete(
        this.baseUrl + `/tables/commissionSignalmanConfigurazions/${commissionConfigurationId}/`,
      )
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'deleteCommissionSignalmanConfiguration');
          return response;
        }),
      );
  }

  saveCommission(commissionSignalmanConfiguration: CommissionsSignalmanModel) {
    return this.http
      .post(
        this.baseUrl + `/tables/commissionSignalmanConfigurazions/save`,
        commissionSignalmanConfiguration,
      )
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'saveCommissionsSignalmanConfiguration');
          return response;
        }),
      );
  }
}
